import * as React from 'react';
import SetOrResetPassword from './SetOrResetPassword';

class ResetPassword extends React.Component <{}, {}> {
    public render() {
        return (
            <SetOrResetPassword title="Reset Password"/>
        );
    }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/Components/Auth/ResetPassword.tsx